module.exports = __webpack_public_path__ + "img/design1.7c95d447.jpg";